import React from 'react';
import './Section.css';
import './Overview.css';
import kiwiLogo from '../assets/Innodata Logo with Kiwi BG.png';

const Overview = () => {
  return (
    <section id="overview" className="section overview-section">
      <div className="section-content overview-container">
        <div className="overview-text">
          <h1>Welcome to Innodata Solutions</h1>
          <p className="subtitle">Smart Solutions. Kiwi Innovation.</p>
          <p>
            Innodata Solutions is a New Zealand-based software company dedicated to empowering
            organisations through innovative, secure, and user-centric digital solutions. From
            clinical health systems and patient workflow tools to commercial platforms, logistics,
            property management, and accounting systems - we build software that fits the way
            your business, workflow and people work, not the other way around.
          </p>
        </div>
        <div className="overview-logo-container">
          <img src={kiwiLogo} alt="Innodata Solutions NZ" className="overview-logo" />
        </div>
      </div>
    </section>
  );
};

export default Overview;
